import React from 'react';
import { ScoreItem } from '@talentmesh/utils';
import UIStrings from '@/Utils/UIStrings';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import PersonalityScoreDetails from './Personality/PersonalityScoreDetails';
import ScoreOverview from './Components/ScoreOverview';

function PersonalityTab(): React.JSX.Element | null {
    const { results, jobFunction } = useCandidatesResultsContext();
    const { personalityScore, candidateFirstName } = results;

    if (personalityScore) {
        const { percentileScore, percentileLevel, testValidity } = personalityScore;

        const overall: ScoreItem = {
            level: percentileLevel,
            name: UIStrings.OverallScore,
            value: percentileScore,
        };

        const scores: ScoreItem[] = personalityScore.factors.map((factor) => {
            return {
                level: factor.percentileLevel,
                name: factor.factorName,
                value: factor.percentileScore,
            };
        });

        return (
            <div className="mb-2.5 flex flex-col gap-2.5">
                <ScoreOverview
                    scoreOverviewTitle={UIStrings.PersonalityScoreOverview}
                    scoreOverviewDescription={UIStrings.AnOverallScoreIsCalculated(jobFunction)}
                    candidateFirstName={candidateFirstName}
                    scores={scores}
                    overall={overall}
                    testValidity={testValidity}
                />
                <PersonalityScoreDetails />
            </div>
        );
    }
    return null;
}

export default PersonalityTab;
